import React, { useContext, useEffect, useState, memo } from 'react';
import AuthContext from '../../contexts/AuthContext';
import CircularProgress from '../../components/CircularProgress';
import ThemeMiddleware from './ThemeMiddleware';
import { ShowError } from '../../helper/Alert';
import { useReactOidc, getUserManager } from '@axa-fr/react-oidc-context';
import LocalStorageService from '../../api/LocalStorageService';
import { User } from 'oidc-client';
import { useHistory } from 'react-router';
const AuthMiddleware = (props: any) => {
  const { oidcUser, events } = useReactOidc() as any;
  const authContext = useContext(AuthContext);
  const userEp = authContext.userEmployeePosition;
  const history = useHistory();

  useEffect(() => {
    async function getUserEmployeePosition() {
      try {
        const apiUrl =
          window.config.apiUrl + 'dashboard/getUserEmployeePosition';
        // const um = (await getUserManager().getUser()) as User;
        const um = (await getUserManager().getUser()) as User;
        if (!um) return history.push('/init-login');
        const token = um.access_token;
        // const token = oidcUser.access_token;
        let headers = {};
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
        $.ajax({
          url: apiUrl,
          type: 'GET',
          dataType: 'json',
          //headers:{Authorization: `Bearer ${token}`},
          headers: headers,
          contentType: 'application/json; charset=utf-8',
          success: function (data) {
            const targetItem = (item: any) => item.isDefault === true;
            const filteredData = data.filter(targetItem);
            const isDefault = filteredData.length ? filteredData[0] : data[0];

            LocalStorageService.setUserPersonCode(isDefault.personCode);

            if (
              authContext.setUserEmployeePosition &&
              authContext.setUserRoles
            ) {
              authContext.setUserEmployeePosition(isDefault);
              authContext.setUserRoles(data);
            }
          },
          error: function (error) {},
        });
      } catch (error) {
        // alert(JSON.stringify(error, undefined, 4));
        return ShowError('', error);
      }
    }

    if (!userEp.personCode) {
      getUserEmployeePosition();
    }
  }, [authContext]);

  useEffect(() => {
    userEpHandler();

    async function userEpHandler() {
      const usrEp = LocalStorageService.getUserPersonCode();

      if (userEp.personCode && usrEp && usrEp !== userEp.personCode)
        LocalStorageService.setUserPersonCode(userEp.personCode);
    }
  });

  // if (!userEp.personCode && !LocalStorageService.getUserPersonCode()) {
  if (!userEp.personCode) {
    return (
      <div className="gx-main-content-wrapper">
        <CircularProgress className="" />
      </div>
    );
  }

  return <ThemeMiddleware {...props} />;
};

export default memo(AuthMiddleware);
